/**
 * UniversalLayout locale 入口
 * @author LiQingSong
 */
import { I18n } from '@/@types/i18n.d';

import zhCN from './zh-CN';
import zhTW from './zh-TW';
import enUS from './en-US';

const locales: I18n = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en-US': enUS,
};

export default locales;
